export default "__VITE_ASSET__CGSw$kUi__"